import { render, staticRenderFns } from "./ChartWithSelectedMonthFailedDelivery.vue?vue&type=template&id=dd6663a6&lang=pug&"
import script from "./ChartWithSelectedMonthFailedDelivery.vue?vue&type=script&lang=ts&"
export * from "./ChartWithSelectedMonthFailedDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./ChartWithSelectedMonthFailedDelivery.vue?vue&type=style&index=0&id=dd6663a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports